"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationResult = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var jyEduStages_1 = require("../../model/jyEduStages");
var service_1 = require("../../../library/base/service");
var ApplicationResult = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ApplicationResult, _super);
    function ApplicationResult() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '审核结果查询接口';
        _this.code = '101100';
        _this.desc = '审核结果查询接口';
        _this.requestParams = new jyEduStages_1.ApplicationResultRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return ApplicationResult;
}(service_1.BaseService));
exports.ApplicationResult = ApplicationResult;
//# sourceMappingURL=applicationResult.js.map